import Tooltip from "_shared/components/Tooltip/Tooltip";
import addons from "_shared/constants/addons";
import plans from "_shared/constants/plans";
import { useSubscriptionsContext } from "account/manageSubscriptions/contexts/SubscriptionsContext";
import { motion } from "framer-motion";
import { BsFillClockFill, BsInfoCircleFill } from "react-icons/bs";
import styles from "./AddonsSelection.module.scss";
import { FaRegClock } from "react-icons/fa";

function AddonsSelection() {
  const { selectedPlanIndex, selectedAddons, toggleAddon, expiringAddons } =
    useSubscriptionsContext();

  const selectedPlan = plans[selectedPlanIndex];

  const variants = {
    default: {
      border: "2px solid var(--black-light)",
      color: "var(--grey)",
    },
    selected: {
      border: "2px solid var(--green)",
      backgroundColor: "var(--black-darker)",
      color: "var(--grey-white)",
    },
    expiring: {
      border: "2px solid var(--green-dark)",
      color: "var(--grey)",
    },
  };

  return (
    <div className={styles.container}>
      {addons.map((addon) => {
        const isSelected = selectedAddons.includes(addon.key);
        const isIncluded = !!selectedPlan.includedAddons?.includes(addon.key);
        const isExpiring = expiringAddons.includes(addon.key);

        const onClick = () => toggleAddon(addon.key);

        const price = isIncluded ? (
          <Tooltip content="This addon is included in the selected plan">
            <div className={styles.includedAddon}>
              <BsInfoCircleFill className={styles.icon} />
              <p className={styles.price}>${addon.price} / month</p>
            </div>
          </Tooltip>
        ) : (
          <p className={styles.price}>${addon.price} / month</p>
        );

        return (
          <motion.button
            key={addon.key}
            onClick={isIncluded ? undefined : onClick}
            style={{
              backgroundColor: "var(--black-light)",
            }}
            whileHover={{
              backgroundColor: "var(--black-darker)",
              border: "2px solid var(--green-dark)",
            }}
            variants={variants}
            animate={
              isSelected || isIncluded
                ? "selected"
                : isExpiring
                ? "expiring"
                : "default"
            }
            className={styles.card}
          >
            {addon.icon && <addon.icon className={styles.icon} />}
            <h3>{addon.name}</h3>
            <p className={styles.description}>{addon.description}</p>
            {price}
            {isExpiring && (
              <Tooltip
                maxWidth={320}
                content="You have access to this addon but it is set to expire at the end of your billing cycle — add it to your subscription again to keep it"
              >
                <div className={styles.expiration}>
                  <FaRegClock />
                </div>
              </Tooltip>
            )}
          </motion.button>
        );
      })}
    </div>
  );
}

export default AddonsSelection;
